<template>
    <div>
        <b-alert show variant="warning">
            {{
                $t(
                    "Random Call is only supported in your web browser. Open Findmate in your browser to start matching."
                )
            }}

            <div class="mt-3">
                <font-awesome-icon icon="fa-duotone fa-info-circle" />
                {{ $t("Tap below to open Findmate in your browser to start matching.") }}
            </div>

            <div class="text-center branded py-3">
                <font-awesome-icon icon="fa-light fa-arrow-down" size="2x" />
            </div>

            <b-btn
                v-if="url"
                @click="openBrowser"
                variant="primary"
                size="lg"
                pill
                block
            >
                <font-awesome-icon
                    icon="fa-duotone fa-arrow-up-right-from-square"
                />
                {{ $t("Open in Browser") }}
            </b-btn>

            <div class="mt-3">
                <b-btn
                    v-if="url"
                    @click="copyUrl"
                    variant="link"
                    size="sm"
                    pill
                    block
                >
                    {{ $t("Copy URL") }}
                </b-btn>
            </div>
        </b-alert>
    </div>
</template>

<script>
import { mapState } from "vuex";
import copy from "clipboard-copy";

export default {
    computed: {
        ...mapState("brand", ["brand"]),
        url() {
            const base = this.brand?.frontendBaseUrl;
            if (!base) return null;
            return `${base.replace(/\/$/, "")}/randomCall`;
        },
    },
    methods: {
        openBrowser() {
            if (!this.url) return;
            this.$store.dispatch("system/openBrowser", this.url);
        },
        copyUrl() {
            if (!this.url) return;
            copy(this.url);
        },
    },
};
</script>
